<template>
  <div class="contentArea pt-0">
    <div :class="componentDetail.divClass">
      <div
        v-if="componentDetail.horizontalCard.value"
        :class="componentDetail.horizontalCard.componentClass"
      >
        <horizontalCard />
      </div>
      <div
        v-if="componentDetail.table.value"
        :class="componentDetail.table.componentClass"
      >
        <div class="grid grid-cols-3  my-6">
          <div class="col-span-1 flex">
            <p class="m-2 text-xl font-semibold text-primary">Year</p>
            <vs-dropdown
              :color="$primary"
              class="border_primary border_radius"
              style="border-radius: 5px;
  border: solid 1px #707070;min-width: 122px !important;"
            >
              2020
              <vs-icon icon="expand_more"></vs-icon>

              <vs-dropdown-menu>
                <vs-dropdown-item> option 1 </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <div class="col-span-2 flex">
            <div class="flex">
              <p class="m-2 pr-2 text-xl font-semibold text-primary">Start</p>
              <vs-dropdown
                :color="$primary"
                class="border_primary border_radius"
                style="border-radius: 5px;
  border: solid 1px #707070;min-width: 122px !important;"
              >
                12/01/2020
                <vs-icon icon="expand_more"></vs-icon>

                <vs-dropdown-menu>
                  <vs-dropdown-item> option 1 </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
            <div class="flex">
              <p class="m-2 px-2 text-xl font-semibold text-primary">To</p>
              <vs-dropdown
                :color="$primary"
                class="border_primary border_radius"
                style="border-radius: 5px;
  border: solid 1px #707070;min-width: 122px !important;"
              >
                31/01/2020
                <vs-icon icon="expand_more"></vs-icon>

                <vs-dropdown-menu>
                  <vs-dropdown-item> option 1 </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </div>
        <tableOnly />
      </div>

      <div
        v-if="componentDetail.board.value"
        :class="componentDetail.board.componentClass"
      >
        <board></board>
      </div>
      <div
        v-if="componentDetail.verticalCard.value"
        :class="componentDetail.verticalCard.componentClass"
      >
        <verticalCard></verticalCard>
      </div>
    </div>
    <!-- <ag-grid/> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import themeConfig from "./../../themeConfig";
import horizontalCard from "./elements/horizontal-card/horizontalCard";
import topButton from "./elements/topTableButton/topTableButton";
import tableOnly from "./elements/ag-grid-table/table_component/tableOnly";
import board from "./elements/board/boardMain";
import verticalCard from "./elements/vertical-card/verticalCard";

export default {
  data() {
    return {
      bermuda: themeConfig.theme.bermuda
    };
  },
  components: {
    tableOnly,
    topButton,
    horizontalCard,
    board,
    verticalCard
  },
  computed: {
    ...mapGetters({
      detail: "home/detailUser",
      getTable: "general/table",
      componentDetail: "general/renderDetail"
    })
  },
  mounted() {
    this.$store.dispatch("general/getRenderDetail");
    this.$store.dispatch("general/getTable", "detail");

    // console.log("log render", this.componentDetail);
  }
};
</script>
<style lang="scss">
@import "../assets/scss/vuexy/_variables.scss";
.border_primary {
  border: 1px solid $primary;
}

.border_radius {
  border-radius: 6px;
}
</style>

<style lang="stylus">
.examplex
  display: flex;
  align-items: center;
  justify-content: center;
  button
    margin: 0px !important;
    &.btnx
      margin-left: 10px !important;
      border-radius: 5px 0px 0px 5px;
    &.btn-drop
      border-radius: 0px 5px 5px 0px;
      border-left: 1px solid rgba(255, 255, 255,.2);
</style>
